import React from "react";
import { Container, Contact, Row, Header, Title } from "../components";
import { FormContainer, InfosContainer } from "../containers";

const ContactPage: React.FC = () => (
  <Contact>
    <Container>
      <Row>
        <Header>
          <Title>contact me</Title>
        </Header>
      </Row>
      <Row>
        <FormContainer />
        <InfosContainer />
      </Row>
    </Container>
  </Contact>
);

export default ContactPage;
